var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root"},[(_vm.checkIsVisible)?_vm._t("virtual-item"):_c('div',{staticClass:"virtual",style:({ height: (_vm.elHeight + "px") })})],2)}
var staticRenderFns = []

export { render, staticRenderFns }